var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.svgClass,attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.iconName}}),(!!_vm.title)?_c('title',[_vm._v(_vm._s(_vm.title))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }